import apiFetch from '../apiFetch'

export default function (dossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `Dossier/${dossierId}/ConfirmCancel`, method: 'PUT', body: null, token: token, lastAccessDate })
}
